import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@fluentui/react';
import { Header } from '../Header';
import { Card } from '@coherence-design-system/controls';
/**
 * A prestyled card to make all of MSRC's forms look and feel the same.
 */
export const FormSectionCard = ({ title, titleAs = 'h2', subtitle, id = undefined, headerId = id ? id + '_header' : undefined, children, }) => (_jsx("div", Object.assign({ id: id, role: 'group', "aria-labelledby": headerId }, { children: _jsxs(Card, Object.assign({ styles: {
            root: {
                ' span': {
                    maxWidth: 580,
                },
                width: '100%',
                minWidth: '288',
            },
        } }, { children: [_jsx(Stack, { children: _jsx(Header, Object.assign({ inCard: true }, { title, subtitle, titleAs, headerId })) }), _jsx(Stack, Object.assign({ horizontalAlign: 'start' }, { children: children }))] })) })));
